import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "fv-row mb-7" })
], -1)

import { ref, inject } from "vue";
import ModelConfirm from "@/components/ModelConfirm.vue";
import ErrorMsg from "@/components/ErrorMsg";
import { apiProviderKey } from "@/core/plugins/providerKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRequestApprove',
  emits: ["approved"],
  setup(__props, { expose: __expose, emit }) {

// import ApiService from "@/core/services/ApiService";
const api = inject(apiProviderKey);

const refAccountRequestApproveModel = ref(null);

const submited = ref(true);

const data = ref({});



const ok = async () => {
  submited.value = true;
  await api["account.applications.approve"]({
    id: data.value.id,
    data: {
      status: "approved",
    },
  })
    .then(({ data }) => {
      submited.value = false;
      emit("aprove", data);
      refAccountRequestApproveModel.value.hide();
    })
    .catch(({ response }) => {
      console.log(response);
      ErrorMsg.show(response);
      submited.value = false;
    });
};

const show = (_data) => {
  refAccountRequestApproveModel.value.show();
  data.value = _data;
  submited.value = false;
};
__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModelConfirm, {
    ok: ok,
    title: _ctx.$t('action.approve'),
    elId: "AccountRequestApprove",
    submited: submited.value,
    submitTitle: _ctx.$t('action.saving'),
    ref_key: "refAccountRequestApproveModel",
    ref: refAccountRequestApproveModel
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["title", "submited", "submitTitle"]))
}
}

})